<div
  class="med-notification-container"
  [ngClass]="classList"
>
  <div class="med-notification-container__content">
    <div class="med-notification-container__icon">
      <ng-container *ngIf="isSuccess; else errorIconTemplate">
        <med-icon-alert-success size="16"></med-icon-alert-success>
      </ng-container>
    </div>

    <ng-content></ng-content>
  </div>

  <med-btn
    *ngIf="showCloseAction"
    class="med-notification-container__close"
    mode="notification"
    (click)="onCloseClicked()"
  >
    <med-icon-x size="14"></med-icon-x>
  </med-btn>
</div>

<ng-template #errorIconTemplate>
  <med-icon-alert-error size="16"></med-icon-alert-error>
</ng-template>
